import { useState, MouseEvent } from 'react';
import { SerializedError } from '@reduxjs/toolkit';
import { useForm, RegisterOptions } from 'react-hook-form';

import { useAppDispatch } from '../../app/hooks';
import {
  loginWithPasswordAction,
  LoginWithPasswordParams,
  loginToOAuthPage,
  forgotPasswordAction,
} from './authSlice';
import { generateRandomString } from '../../common/generate-random-string';
import { route_path } from '../../app/route';
import { Link } from 'react-router-dom';

const initialState: LoginWithPasswordParams = {
  username: '',
  password: '',
};

const field_options: Partial<Record<keyof LoginWithPasswordParams, RegisterOptions>> = {
  username: { 
    required: 'Username is required',
  },
  password: {
    required: 'Password is required',
  },
};

export function Login() {
  const dispatch = useAppDispatch();
  const { register, handleSubmit, watch, formState: { errors } } = useForm({
    defaultValues: initialState,
  });
  const [api_error, setApiError] = useState<SerializedError|undefined>();

  const onLogin = async(data: typeof initialState) => {
    let login_result = await dispatch(loginWithPasswordAction(data));
    if (loginWithPasswordAction.rejected.match(login_result)) {
      setApiError(login_result.error);
      const subscription = watch(() => {
        setApiError(undefined);
        subscription.unsubscribe();
      });
    }
  };

  const username = watch('username');
  const onForgotPassword = async(e: MouseEvent) => {
    e.preventDefault();
    let result = await dispatch(forgotPasswordAction({
      email: username,
    }));
    if (forgotPasswordAction.fulfilled.match(result)) {
      setApiError({
        name: 'Please click link from your email'
      });
    } else if (forgotPasswordAction.rejected.match(result)) {
      setApiError(result.error);
    }
  };

  const onLoginGoogle = (e: MouseEvent) => {
    e.preventDefault();
    dispatch(loginToOAuthPage({
      provider: 'google',
      redirect_uri: window.location.href,
      state: generateRandomString(18),
    }));
  };
  const onLoginFacebook = (e: MouseEvent) => {
    e.preventDefault();
    dispatch(loginToOAuthPage({
      provider: 'facebook',
      redirect_uri: window.location.href,
      state: generateRandomString(18),
    }));
  };
  const onLoginLINE = (e: MouseEvent) => {
    e.preventDefault();
    dispatch(loginToOAuthPage({
      provider: 'line',
      redirect_uri: window.location.href,
      state: generateRandomString(18),
    }));
  };
  return (
    <div className="container-lg">
      <div className="row justify-content-md-center">
        <form className="col col-md-5 card border-dark mb-3 mt-5" onSubmit={handleSubmit(onLogin)}>
          <div className="card-body">
            <div className="mb-3">
              <label htmlFor="account" className="form-label">Account</label>
              <input
                className="form-control"
                id="account"
                placeholder="account"
                { ...register('username', field_options.username) }
              />
              <span className="text-danger">{errors.username?.message}</span>
            </div>
            <div className="mb-3">
              <label htmlFor="password" className="form-label">Password</label>
              <input
                type="password"
                className="form-control"
                id="password"
                placeholder="password"
                { ...register('password', field_options.password) }
              />
              <span className="text-danger">{errors.password?.message}</span>
            </div>
            <span className="text-danger">{api_error?.message ?? api_error?.name}</span>
            <div className="d-grid gap-2 mt-5">
              <button type="submit" className="btn btn-outline-primary">Login</button>
              <Link to={route_path.signup} className="btn btn-outline-primary">Sign Up</Link>
              <button className="btn btn-outline-primary" onClick={onForgotPassword}>Forgot Password</button>
              <button className="btn btn-outline-primary" onClick={onLoginGoogle}>Login by Google</button>
              <button className="btn btn-outline-primary" onClick={onLoginFacebook}>Login by Facebook</button>
              <button className="btn btn-outline-primary" onClick={onLoginLINE}>Login by LINE</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
